import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';

@Component({
  standalone: true,
  imports: [CommonModule,MatIconModule,MatButtonModule,MatTooltipModule],
  selector: 'app-button-export-excel',
  templateUrl: 'button-export-excel.component.html',
  styleUrls: ['./button-export-excel.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})



export class ButtonExportExcelComponent {
  @Input() data: any[] = [];
  @Input() fileName: string = 'reporte';
  @Input() columns: { header: string, key: string, width?: number }[] = [];
  @Input() sheetName: string = 'Datos';
  @Input() buttonLabel?: string;

  exportar(): void {
    if (!this.data || this.data.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(this.sheetName);

    worksheet.columns = this.columns;

    worksheet.addRows(this.data);

    // Opcional: aplicar estilos al encabezado
    worksheet.getRow(1).eachCell(cell => {
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFEEEEEE' }
      };
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      FileSaver.saveAs(blob, `${this.fileName}_${new Date().getTime()}.xlsx`);
    });
  }

  getDate(): string {
  const now = new Date();
  const pad = (n: number) => n.toString().padStart(2, '0');

  return `${pad(now.getDate())}-${pad(now.getMonth() + 1)}-${now.getFullYear()}`;
}
}

